import { Language as RawLanguage } from '../../modules/backend/openapi/api-types';

export const Language = RawLanguage;
export type Language = RawLanguage;

export const DEFAULT_LANGUAGE = Language.en;
